import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { fetchRegistry } from '../../../../actions/RegistryActions';
import { showModal } from '../../../../actions/ModalActions';
import { fetchPages, getProfileImage } from '../../../../actions/website/PageActions';
import { toggleWebsite } from '../../../../actions/WeddingActions';
import WebsiteNav from '../../../common/header/SecondaryNav/SecondaryNav';
import { weddingWebsiteNavItems } from '../../../common/header/SecondaryNav/secondaryNavData';
import Header from './Header/Header';
import WebAdmin from './WebAdmin/WebAdmin';
import Pages from './Pages/Pages';
import Hero from './Hero/Hero';
import CardsList from './Cards/Cards';
import paperImg from '../../../../assets/images/website/manage-redesign/paper.svg';
import './ManagePagesRedesign.styles.less';

class ManagePagesRedesign extends React.Component {
  componentDidMount() {
    const {
      pages,
      hasRegistry,
      getPages,
      getRegistry,
      registry,
      handleGetProfileImage
    } = this.props;

    if (pages.orderedIds.length === 0) {
      getPages();
    }

    // if registry status doesn't exist, that means registry info has not been fetched yet
    if (hasRegistry && !registry.status) {
      getRegistry();
      handleGetProfileImage();
    }


    if (window.zolaNav) {
      window.zolaNav.setTopLinkActive();
    }
  }

  toggleWebsitePublish = () => {
    const { account: { published }, onPublishWebsite, showPublishWebsiteModal, openHidePagesModal } = this.props;

    if (published) {
      onPublishWebsite(!published).then(() => {
        if (!published) {
          return showPublishWebsiteModal();
        }

        return false;
      });
    } else {
      openHidePagesModal();
    }
  }


  render() {
    const { slug, shareInfo, pageKey, wedding, profileImage, account, theme, themeGroupTitle } = this.props;

    return (
      <div className="manage-pages-redesign">
        <Helmet defaultTitle="Zola Weddings" />
        <WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} />
        <Header wedding={wedding} profileImage={profileImage} />
        <WebAdmin themeGroupTitle={themeGroupTitle} theme={theme} account={account} publishWebsite={this.toggleWebsitePublish} wedding={wedding} />
        <Pages />
        <Hero>
          <img
            className="mpr-hero__img"
            src={paperImg}
            alt="Paper"
          />
          <div className="mpr-hero__group">
            <h1 className="mpr-hero__title">Add Matching Wedding Paper</h1>
            <p className="mpr-hero__subtitle">
            Create everything from save the dates to invites, programs, and even thank you cards that go {' '}
              <span className="mpr-hero__subtitle--underline">perfectly</span> with your website.
            </p>
          </div>
        </Hero>
        <CardsList />
      </div>
    );
  }
}

ManagePagesRedesign.propTypes = {
  account: PropTypes.shape({}),
  hasRegistry: PropTypes.bool,
  pages: PropTypes.shape({}),
  getRegistry: PropTypes.func,
  getPages: PropTypes.func,
  theme: PropTypes.shape({}),
  slug: PropTypes.string,
  wedding: PropTypes.shape({}),
  shareInfo: PropTypes.shape({}),
  pageKey: PropTypes.string,
  registry: PropTypes.shape({}),
  onPublishWebsite: PropTypes.func.isRequired,
  handleGetProfileImage: PropTypes.func,
  profileImage: PropTypes.string,
  themeGroupTitle: PropTypes.string,
  showPublishWebsiteModal: PropTypes.func,
  openHidePagesModal: PropTypes.func,
};

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
  account: state.wedding.account,
  hasRegistry: state.user.userContext.has_registry,
  registry: state.registry,
  theme: state.wedding.theme,
  guestGroups: state.guestList.guests.byId,
  pages: state.website.pages,
  slug: state.wedding.wedding.slug,
  published: state.wedding.account.published,
  themeGroupTitle: state.wedding.themeGroupTitle,
  hideablePages: state.website.pages.hideablePagesById,
  profileImage: state.website.pages.profileImage
});

const mapDispatchToProps = dispatch => ({
  getRegistry: () => dispatch(fetchRegistry()),
  getPages: () => dispatch(fetchPages()),
  handleGetProfileImage: () => dispatch(getProfileImage()),
  onPublishWebsite: published => dispatch(toggleWebsite(published)),
  showPublishWebsiteModal: () => dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'md' })),
  openHidePagesModal: () => dispatch(showModal('HIDE_PAGES', {}, { size: 'md' })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagePagesRedesign);



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/ManagePagesRedesign.jsx